import fetchData from '../fetchData/fetchData';

/**
 * Retrieve UGC user data from pathAuth cookie.
 * @param  {String} pathAuth - pathAuth cookie value.
 * @return {Promise} The fetch-based promise that will resolve with the results.
 */
function getUGCUserInfoByPathAuth(pathAuth) {
  return fetchData('GET', `/ugc/users/regiauthtoken/${pathAuth}`);
}

/**
 * Retrieve UGC user data from UGC user id.
 * @param  {String} ugcId - The UGC id.
 * @return {Promise} The fetch-based promise that will resolve with the results.
 */
function getUGCUserInfoById(userId) {
  return fetchData('GET', `/ugc/users/?id=${userId}&limit=1`);
}

/**
 * If successful, retrieves settings for a particular user.
 * @param {string} token - pathAuthJWT token, is the key to look up the user.
 * @returns {Promise} The fetch-based promise that will resolve with the results.
 */
function getUserInfoByPathAuthJWT(token) {
  return fetchData(
    'GET',
    '/profiles/outside/REST/auth/getuserbytoken?Site=bostonglobe',
    false,
    {},
    {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  );
}

/**
 * Retrieve UGC user interactions from UGC user id.
 * @param  {String} userId - The UGC user id.
 * @param  {Int} limit - The total number of interactions to retrieve.
 * @param  {Int} offset - The offset of the interactions to retrieve.
 * @return {Promise} The fetch-based promise that will resolve with the results.
 */
function getUGCUserInteractions(userId, limit = 10, offset = 0) {
  const sort = 'NEWEST_CREATE_DT';
  const approvalStatus = 'UNMODERATED';
  const type = 'ARTICLE_COMMENT';
  return fetchData('GET', `/ugc/interactions?actingUser=${userId}&limit=${limit}&sort=${sort}&approvalStatus=${approvalStatus}&offset=${offset}&type=${type}`);
}

/**
 * Saves the settings for a particular users.
 * @param {String} userId - The user to update.
 * @param {Object} formData - Contains the fiels aboutMe and profileVisibility.
 * @returns {Promise} The fetch-based promise that will resolve with the results.
 */
function patchUser(userId, formData) {
  return fetchData('PATCH', `/ugc/users/${userId}`, formData);
}

/**
 * Posts a new avatar for the user.
 * @param {String} userId - The user ID to get the activity of.
 * @param {Object} formData - Form data instance.
 * @returns {Promise} The fetch-based promise that will resolve with the results.
 */
function postUserAvatar(userId, formData) {
  return fetchData('POST', `/ugc/users/${userId}/avatar`, formData, true);
}

export { 
  getUGCUserInfoByPathAuth, 
  getUGCUserInfoById, 
  getUserInfoByPathAuthJWT,
  getUGCUserInteractions, 
  patchUser, 
  postUserAvatar 
};



// WEBPACK FOOTER //
// ./src/utilities/userUtil/userUtil.js